module.exports = __webpack_public_path__ + "img/tb-act.c85eab8c.png";